<template>
  <div>
    <el-card class="release-card">
      <el-row>
        <el-col :span="14">
          <h5 class="species-name">
            <!-- <router-link :to="{path: '/genome/'+item.name, query: {assembly: item.assem.split(' ')[1]}}" -->
            <router-link :to="{path: '/genome/'+item.full_name}"
            style="text-decoration: none; color: #2c7fb8;">
              {{ formattedFullName }}
            </router-link>
          </h5>
          <span class="common-name">{{ item.common_name }} • {{ item.Chinese_name }}</span>

          <el-tooltip :content="item.description" placement="top">
            <p>
              <a :href="item.doi" target="_blank" rel="noopener noreferrer">
                <el-tag type="success" size="small">DOI</el-tag>
              </a >
              {{ item.description | trimLong }}
            </p >        
          </el-tooltip>
        </el-col>
        <el-col :span="6">
          <div>
            <el-badge :value="item.anno" type="primary" class="item">
              <el-tag size="small" type="info" style="margin-bottom: 1rem;" effect="plain"><a :href="item.link" target="_blank" rel="noopener noreferrer">Annotation</a ></el-tag>
            </el-badge>
          </div>
          <div>
            <el-badge :value="item.assem" type="primary" class="item">
              <el-tag size="small" type="info" effect="plain"><a :href="item.link" target="_blank" rel="noopener noreferrer">Assembly</a ></el-tag>
            </el-badge>
          </div>
        </el-col>
        <el-col :span="4" style="text-align: center;">
          <img class="card-spe-img" :src="item.img_src" width="64px" height="64px">
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>


<script>
export default {
  created() {
    // console.log(this.item)
  },
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  filters: {
    trimLong: function(value) {
      if(!value) return ''
      if(value.length>53){
        return value.slice(0,45)+'...'
      }else{
        return value
      }
    }
  },
  computed: {
    formattedFullName() {
      // 将下划线替换为空格
      return this.item.full_name.replace(/_/g, ' ');
    }
  }
}
</script>

<style lang="scss">
  .release-card{
    h5 {
      margin-bottom: 0;
    }
    p {
      margin-bottom: 0;
    }
    .el-badge__content {
      font-size: .5rem;
    }
  }
  .card-spe-img {
    border: 2px ridge #deebf788;
  }
</style>